import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Alert } from 'antd';
import { toast } from 'react-toastify';
import ContentLayout from '../../layout/ContentLayout';
import { Container } from '../../components/content';
import ProtocolFormWizard from '../../components/protocols/ProtocolFormWizard';
import protocolApi from '../../api/protocol-api';
import { protocolToDuplicateFormData, toDaysPayload } from '../../utils/protocol-form.util';
import styles from '../../styles/mobileInfoPage.module.scss';

export default function DodajProtokol() {
  const navigate = useNavigate();
  const location = useLocation();
  const [saving, setSaving] = useState(false);

  // Set once by the "Dupliciraj" action on the protocol list. Seeded through
  // state rather than a query param because the whole protocol travels with
  // it, days included.
  const duplicateFrom = location.state?.duplicateFrom;
  const [initialForm] = useState(() =>
    duplicateFrom ? protocolToDuplicateFormData(duplicateFrom) : undefined,
  );

  const handleCreate = async (formData) => {
    setSaving(true);

    const payload = {
      subcategories: formData.subcategories?.length ? formData.subcategories : undefined,
      categories: formData.categories,
      rank: formData.rank ?? undefined,
      name: formData.name,
      imageUrl: formData.imageUrl || undefined,
      durationDays: formData.durationDays,
      weightRanges: formData.weightRanges,
      versionNotes: formData.versionNotes || undefined,
      days: toDaysPayload(formData.days),
    };

    const { success, message } = await protocolApi.create(payload);
    if (success) {
      toast.success('Protokol kreiran');
      navigate('/protokoli?tab=protokoli');
    } else {
      toast.error(message || 'Greška pri kreiranju protokola');
    }
    setSaving(false);
  };

  return (
    <Container>
      <Link to="/protokoli?tab=protokoli" className="link_btn" style={{ marginBottom: '12px' }}>
        <img alt="back" src="/assets/icons/chevron.svg" />
        <span>Nazad</span>
      </Link>

      <ContentLayout pt={true}>
        <h2 className={styles.pageTitle} style={{ marginBottom: '24px' }}>
          {initialForm ? 'Dupliciraj protokol' : 'Novi protokol'}
        </h2>

        {initialForm && (
          <Alert
            style={{ marginBottom: '24px' }}
            type="info"
            showIcon
            message="Kreira se potpuno nov protokol sa kopiranim podacima — original ostaje nepromenjen. Trajanje i opseg težine možete promeniti samo ovde, pre čuvanja."
          />
        )}

        <ProtocolFormWizard
          mode="create"
          initialForm={initialForm}
          saving={saving}
          onSubmit={handleCreate}
        />
      </ContentLayout>
    </Container>
  );
}
